"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CategoryFilterDropdown = CategoryFilterDropdown;
var _react = require("react");
var _command = require("@design/ui/command");
var _popover = require("@design/ui/popover");
var _foldedTextSearch = require("@common/utils/foldedTextSearch");
var _portalLayer = require("@common/components/share/portal-layer");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["trigger", "categoryLabel"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var CATEGORY_LABEL_PLURAL = {
  category: "categories",
  tag: "tags"
};
function CategoryFilterList(_ref) {
  var categories = _ref.categories,
    selectedCategories = _ref.selectedCategories,
    onToggleCategory = _ref.onToggleCategory,
    categoryLabelPlural = _ref.categoryLabelPlural;
  var _useState = (0, _react.useState)(""),
    _useState2 = _slicedToArray(_useState, 2),
    searchQuery = _useState2[0],
    setSearchQuery = _useState2[1];
  var filtered = categories.filter(function (category) {
    return (0, _foldedTextSearch.matchesSearch)(category, searchQuery);
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_command.Command, {
    shouldFilter: false,
    label: "Search ".concat(categoryLabelPlural, "\u2026"),
    "data-sentry-element": "Command",
    "data-sentry-component": "CategoryFilterList",
    "data-sentry-source-file": "category-filter-dropdown.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_command.CommandInput, {
      autoFocus: true,
      placeholder: "Search ".concat(categoryLabelPlural, "\u2026"),
      value: searchQuery,
      onValueChange: setSearchQuery,
      "data-sentry-element": "CommandInput",
      "data-sentry-source-file": "category-filter-dropdown.tsx"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_command.CommandList, {
      "data-sentry-element": "CommandList",
      "data-sentry-source-file": "category-filter-dropdown.tsx",
      children: [filtered.map(function (category) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_command.CommandItem, {
          value: category,
          checkbox: selectedCategories.includes(category),
          onSelect: function onSelect() {
            return onToggleCategory(category);
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            className: "fit-truncate",
            children: category
          })
        }, category);
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_command.CommandEmpty, {
        "data-sentry-element": "CommandEmpty",
        "data-sentry-source-file": "category-filter-dropdown.tsx",
        children: ["No ", categoryLabelPlural, " found"]
      })]
    })]
  });
}
function CategoryFilterDropdown(_ref2) {
  var trigger = _ref2.trigger,
    categoryLabel = _ref2.categoryLabel,
    listProps = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_popover.Popover, {
    "data-sentry-element": "Popover",
    "data-sentry-component": "CategoryFilterDropdown",
    "data-sentry-source-file": "category-filter-dropdown.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_popover.PopoverTrigger, {
      asChild: true,
      "data-sentry-element": "PopoverTrigger",
      "data-sentry-source-file": "category-filter-dropdown.tsx",
      children: trigger
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_popover.PopoverContent, _objectSpread(_objectSpread({
      align: "end",
      className: "w-64 overflow-hidden"
    }, _portalLayer.PORTAL_LAYER_PROPS), {}, {
      "data-sentry-element": "PopoverContent",
      "data-sentry-source-file": "category-filter-dropdown.tsx",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(CategoryFilterList, _objectSpread(_objectSpread({}, listProps), {}, {
        categoryLabelPlural: CATEGORY_LABEL_PLURAL[categoryLabel],
        "data-sentry-element": "CategoryFilterList",
        "data-sentry-source-file": "category-filter-dropdown.tsx"
      }))
    }))]
  });
}